var _g, _rect, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPauseSpinning(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "25px",
    id: "e97dch6KfpA1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 26 26",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-.441189 0.200194)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    mask: "url(#e97dch6KfpA6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "e97dch6KfpA5",
    d: "M13.4412,12.7998c0,6.9036-.000027,12.5,0,12.5-6.9036,0-12.500038-5.5964-12.500038-12.5s12.500038-12.499995,12.500038-12.499995s0,5.596445,0,12.499995Zm-10.00004,0c0,5.5229,10.00004,10,10.00004,10s-.000027-4.4771-.000027-10s.000027-10,.000027-10-10.00004,4.47716-10.00004,10Z",
    transform: "translate(.04878 0.048771)",
    fill: "none",
    stroke: "#b7844d",
    strokeWidth: 4,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "e97dch6KfpA6",
    "mask-type": "luminance",
    x: "-150%",
    y: "-150%",
    height: "400%",
    width: "400%"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.9412,12.7998c0,6.9036-5.5965,12.5-12.5,12.5-6.9036,0-12.500038-5.5964-12.500038-12.5s5.596438-12.499995,12.500038-12.499995s12.5,5.596445,12.5,12.499995Zm-22.50004,0c0,5.5229,4.47715,10,10.00004,10s10-4.4771,10-10-4.4772-10-10-10-10.00004,4.47716-10.00004,10Z",
    fill: "#fff"
  })))))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 2.877509,
    height: 10.116632,
    rx: 0,
    ry: 0,
    transform: "matrix(.932202 0 0 0.985831 9.16 8.062123)",
    fill: "#b7844d",
    strokeWidth: 0
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 2.877509,
    height: 10.116632,
    rx: 0,
    ry: 0,
    transform: "matrix(.932202 0 0 0.985831 14.16 8.062123)",
    fill: "#b7844d",
    strokeWidth: 0
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPauseSpinning);
export default __webpack_public_path__ + "static/media/Pause-spinning.7f4b5567fec1d3616697b57d9cbf2883.svg";
export { ForwardRef as ReactComponent };